import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface UpdateUserPayload {
  userName: string;
  phoneNumber: string;
  email: string;
}

/**
 * Updates an existing user.
 *
 * @param userId - ID of the user to update.
 * @param payload - Updated user details.
 * @param token - Authentication token.
 */
export async function updateUserAsync(
  userId: number,
  payload: UpdateUserPayload,
  token: string
): Promise<any> {
  if (!navigator.onLine) {
    toast.error("Please check your internet connection.", {
      toastId: "offline-error",
    });

    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/UpdateUser/${userId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      let errorMessage = "Failed to update user";

      try {
        const errorData = await response.json();
        errorMessage =
          errorData?.message ||
          errorData?.title ||
          errorMessage;
      } catch {
        const errorText = await response.text();
        errorMessage = errorText || errorMessage;
      }

      throw new Error(errorMessage);
    }

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
      return await response.json();
    }

    return await response.text();
  } catch (error) {
    throw error;
  }
}